import React from 'react';
import { ConfigSortableList } from '@sierralabs/core-ui';
import ComponentPicker from '../../common/pickers/ComponentPicker';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSiteContext } from '../../SiteContext';
import { ComponentRenderer } from '../renderers';
import { SiteComponent } from '../SiteComponentPlugin';
import { useState } from 'react';
export const SiteComponentStack = props => {
    var _a;
    const component = useSubscribeComponentChanges(SiteComponentStackPlugin, props);
    const { editing } = useSiteContext();
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteComponentStackPlugin }, props), (_a = component.children) === null || _a === void 0 ? void 0 : _a.map(child => (React.createElement(ComponentRenderer, { key: child.id, component: child })))));
};
export const SiteComponentStackConfigurator = props => {
    const { component, removeChild, moveChild, changeType, insertChild } = useConfigComponent(props.component);
    const { plugins } = useSiteContext();
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigSortableList, { data: component.children || [], keyIndicator: item => item.id || item.name, renderItem: (item, index) => {
                return (React.createElement(SiteComponentStackItem, { label: props.label || undefined, value: item, onChange: type => changeType(type, `children[${index}]`) }));
            }, footer: React.createElement(SiteComponentStackItem, { onChange: type => {
                    const plugin = plugins.find(p => p.type === type);
                    insertChild(type, plugin.name);
                } }), onDelete: index => {
                removeChild(index);
            }, onMove: (sourceIndex, destinationIndex) => {
                moveChild(sourceIndex, destinationIndex);
            } })));
};
const SiteComponentStackItem = ({ value, label, onChange }) => {
    const [type, setType] = useState((value === null || value === void 0 ? void 0 : value.type) || '');
    return (React.createElement(ComponentPicker, { label: label || 'Component', value: type, onTypeChange: type => {
            if (value)
                setType(type);
            onChange === null || onChange === void 0 ? void 0 : onChange(type);
        } }));
};
export const SiteComponentStackPlugin = {
    name: 'Site Component Stack',
    type: 'component-stack',
    component: SiteComponentStack,
    configurator: SiteComponentStackConfigurator
};
//# sourceMappingURL=SiteComponentStackPlugin.js.map